import { AccountBox } from '@mui/icons-material';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { DataTableColumn, PaginatedProps, StandardListViewV2 } from '../../Components/CoreLib/library';
import { triaxReferenceNumberColumnKeySuffixes } from '../../constants/triaxReferenceNumberColumnKeySuffixes';
import { UserDto } from '../../dtos';
import { useArchiveUserBulkDeleteMutation, useGetUserQuery, useUserBulkArchiveMutation, useUserBulkUnarchiveMutation } from '../../store/generated/generatedApi';
import { usePageTitleSetter } from '../../util';

const defaultPaginationProps: PaginatedProps = {
    sortKey: 'FIRST_NAME',
    sortAsc: true,
    page: 0,
    pageSize: 25,
};

export const UserListView: FC = () => {
    const navigate = useNavigate();
    usePageTitleSetter('Users');

    const tableColumns: DataTableColumn<UserDto>[] = [
        { key: 'firstName', label: 'First Name', sortKey: 'FIRST_NAME' },
        { key: 'lastName', label: 'Last Name', sortKey: 'LAST_NAME' },
        { key: 'title', label: 'Title', sortKey: 'TITLE' },
        { key: 'email', label: 'Email', sortKey: 'EMAIL' },
        { key: 'displayRoles', label: 'Roles', sortKey: 'ROLES' },
        { key: 'phoneNumber', label: 'Phone', sortKey: 'PHONE_NUMBER' },
    ];

    const handleCreateNew = () => {
        navigate('/user/create');
    };

    const handleTableEdit = (id: string) => {
        navigate(`/user/${id}`);
    };

    return (
        <StandardListViewV2
            referenceNumberColumnKeySuffixes={triaxReferenceNumberColumnKeySuffixes}
            enableMultiSort
            headerIcon={<AccountBox />}
            headerTitle='Users'
            breadCrumbs={[
                { label: 'Home', navLink: '/' },
                { label: 'Admin', navLink: '', isText: true },
            ]}
            defaultPaginationProps={defaultPaginationProps}
            getDataQuery={useGetUserQuery}
            isShowActiveToggleVisible
            inactivateMutation={useUserBulkArchiveMutation}
            activateMutation={useUserBulkUnarchiveMutation}
            deleteMutation={useArchiveUserBulkDeleteMutation}
            tableColumns={tableColumns}
            entityNameSingular='User'
            permissionName='users'
            handleAdd={handleCreateNew}
            handleEdit={handleTableEdit}
            paginationOnTop={true}
            stickyTableHeader={true}
        />
    );
};
